<template src="./template.html"></template>
<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import PageHeading from '../../modules/03_page_heading';
    import {
        ERASE_SELECTED_PANEL
    } from '../../../store/types';

    export default {
        components: { PageHeading },
        props: ['step'],
        beforeMount () {
            this.$store.dispatch('UPDATE_STEPS', this.$props.step);
        },
        created () {
            if (!this.get_building_info) {
                this.fetchBuildings().then(() => {
                    const building = this.get_building_by_slug(this.$route.params.buildingAddress);
                    this.$store.dispatch('SET_ACTIVE_BUILDING', building.id);
                });
            }
            this.unlockPanels();
        },
        computed: {
            ...mapGetters(['get_wording', 'get_buildings', 'get_building_info', 'get_fileds', 'get_selection',
                'get_order_created', 'get_panels', 'get_selected_building_slug', 'get_field_by_id', 'get_building_by_slug']),
            building () {
                return this.get_building_info;
            },
            buildingImage () {
                return this.$resourcesUrl + this.building.image;
            },
            calcFieldPosition () {
                if (this.building) {
                    return `
                        left: ${this.building.fields_left_position}px;
                        top: ${this.building.fields_top_position}px;
                        width: ${this.building.building_width}px;
                    `;
                }
            },
            calcFieldDimensions () {
                if (this.building) {
                    return `
                    width: ${this.building.field_width}px;
                    height: ${(this.building.field_width - 2)}px;
                `;
                }
            },
        },
        methods: {
            nextStep () {
                this.$router.push(`/${this.get_selected_building_slug}/step-2`);
            },
            chooseField (id, availablePanels, index) {
                // if (availablePanels > 0) {
                    this.$store.dispatch('SET_ACTIVE_FIELD', {
                        id: id,
                        index: index,
                    });

                    const field = this.get_field_by_id(id);

                    if (field.panels) {
                        this.$store.dispatch('SET_PANELS', field.panels);
                        this.nextStep();
                    } else {
                        // Load panels for selected field
                        this.$store.dispatch('SET_LOADER', true);

                        axios.get(`${this.$apiUrl}/building/${this.get_selection.activeBuilding}/field/${id}`)
                            .then((response) => {
                                this.$store.dispatch('SET_LOADER', false);
                                this.$store.dispatch('SET_PANELS', response.data.data.panels);
                                this.nextStep();
                            });
                    }
                // } else {
                    // this.$store.dispatch('SET_NOTIFICATION', {
                    //     message: this.get_wording.no_available_panels,
                    //     type: 'warning'
                    // });
                // }
            },
            removeSelectedClass () {
                if (this.get_selection.activeField) {
                    document.getElementById(`panel-cell-${(this.get_selection.activeField)}`).classList.remove('selected');
                }
            },
            fetchBuildings() {
                this.$store.dispatch('SET_LOADER', true);
                return axios.get(`${this.$apiUrl}/building/list`)
                    .then((response) => {
                        this.$store.dispatch('SET_LOADER', false);
                        this.$store.dispatch('SET_BUILDINGS', response.data.data);

                        return response.data.data;
                    })
                    .catch(function (error) {
                    });
            },
            unlockPanels() {
                const activePanels = this.get_selection.activePanels;
                if (activePanels.length && !this.get_order_created) {
                    this.setPanelAvailable(activePanels.join());
                    this.$store.dispatch(ERASE_SELECTED_PANEL);
                }
            },
            setPanelAvailable(panelId) {
                const selection = this.get_selection;
                const buildingId = selection.activeBuilding;
                const fieldId = selection.activeField;
                const panelApiRoute = `${this.$apiUrl}/building/${buildingId}/field/${fieldId}/panel/available`;
                axios.post(panelApiRoute, { panel_id: panelId });
            },
        },
    };

</script>



// WEBPACK FOOTER //
// src/components/pages/01_building/index.vue